import React from 'react'

import { PaginatedTable, PaginatedTableCallbacks } from '../../common'
import { InvalidSupplierTable } from './table'
import { JsonRecord, Record } from '../../../models'
import { getRecordsWithInvalidSupplier } from '../../../api'
import { getAuthUser } from '../../../helpers';
import defineAbilityFor from '../defineAbility'
import { InsufficientPermissions } from '../../common';

export const InvalidSupplier = () => {
    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('View', 'Record')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<Record, JsonRecord>
            getData={getRecordsWithInvalidSupplier}
            modelConstructor={(json: JsonRecord) => new Record(json)}
            searchPlaceholder='Search by REC, Phone, or Supplier Name'
            Table={(records: Record[], callbacks: PaginatedTableCallbacks) => (
                <InvalidSupplierTable
                    callbacks={callbacks}
                    resources={{ records }} />
            )}
            title='Records with invalid supplier' />
    )
}
